import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import useLoginForm from '../../hooks/UseLoginForm';
import { auth, googleProvider } from '../../firebase';
import { signInWithPopup } from 'firebase/auth';
import usersAPI from '../../api/users';

export default function WebLogin() {
  const navigate = useNavigate();
  const [googleLoading, setGoogleLoading] = useState(false);

  const {
    email,
    setEmail,
    password,
    setPassword,
    error,
    loading,
    handleSubmit,
  } = useLoginForm();

  // 🔁 Shared redirect handler
  const handleLoginSuccess = async () => {
    try {
      const res = await usersAPI.getProfile();
      const profile = res.data;

      const isIncomplete =
        !profile.firstName || !profile.lastName || !profile.address?.country;

      if (isIncomplete) {
        navigate('/signup?step=1');
      } else {
        navigate('/dashboard');
      }
    } catch (err) {
      console.error('Profile check failed:', err.message);
      navigate('/dashboard');
    }
  };

  // 🔐 Google Login
  const signInWithProvider = async (provider) => {
    try {
      setGoogleLoading(true);
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      if (!user) throw new Error('Google login failed');
      await handleLoginSuccess();
    } catch (error) {
      console.error('Google Sign-In Error:', error.message);
    } finally {
      setGoogleLoading(false);
    }
  };

  return (
    <div className="flex h-screen max-w-7xl mx-auto">
      {(loading || googleLoading) ? (
        <div className="flex flex-col items-center justify-center w-full">
          <div className="mb-6 animate-pulse">
            <p className="text-sm text-gray-500 text-center mt-2">
              Gearing up your dashboard...
            </p>
          </div>
        </div>
      ) : (
        <>
          {/* Left Image 
          <div className="relative w-1/2 h-full hidden md:block bg-white">
            <img
              src={img}
              alt="Background"
              className="absolute inset-0 w-full h-full object-cover rounded-l-lg"
            />
          </div>*/}

          {/* Right Form */}
          <div className='relative h-screen w-full overflow-hidden'>
          <div
            className="absolute inset-0 z-0 bg-cover bg-center"
            style={{
              backgroundImage: `url('https://res.cloudinary.com/dk0nzszcz/image/upload/v1746929148/photo1_lgvyzk.jpg')`
            }}
          ></div>
          {/* Dark Overlay */}
          <div className="absolute inset-0 z-0 bg-black bg-opacity-50"></div>
          
          {/* Login Form */}

          <div className="w-full md:w-1/2 flex items-center justify-center rounded-r-lg z-10 relative">
            <div className="max-w-md w-full mt-8">
              <h2 className="text-7xl mb-2 p-3 text-white font-cormorant text-center font-medium">
                Find Your Next Horse Today
              </h2>

              <form
                onSubmit={(e) => handleSubmit(e, handleLoginSuccess)}
                className="p-6 w-full max-w-sm m-auto font-goudy text-text"
              >
                {error && (
                  <p className="text-red-500 text-sm mb-4 text-center">{error}</p>
                )}

                <label className="block mb-2 text-md font-medium text-white">Email</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full px-3 py-2 rounded mb-6 border-2 border-light"
                  required
                />

                <label className="block mb-2 text-md font-medium text-white">Password</label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full px-3 py-2 rounded mb-6 border-2 border-light"
                  required
                />

                <button
                  type="submit"
                  className="w-full bg-cream text-primary py-2 mt-2 rounded text-lg mb-4"
                >
                  Log In
                </button>

                <button
                  onClick={() => signInWithProvider(googleProvider)}
                  className="w-full mt-6 bg-cream text-primary py-2 rounded text-lg"
                >
                  Continue with Google
                </button>

                <div className="text-lg text-center text-white mt-5">
                  Don't have an account?{" "}
                  <Link to="/signup" className="text-white underline">
                    Sign up
                  </Link>
                </div>

                <div className="text-xs text-center text-white mt-3">
                  <p>Amanda: <strong>amanda@test.com</strong> / <strong>testing</strong></p>
                </div>
              </form>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}